import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import Loupe from '@/components/landing/loupe'
import { siteConfig } from '@/constants/site'

/* The hero fills this frame and must start at the viewport's top-left: the
 * glass follows the pointer in window coordinates and is sized off the window. */
const Home: FC = (): ReactNode => {
    return (
        <main className='relative h-dvh w-full overflow-hidden'>
            <Seo />

            <h1 className='sr-only'>
                {siteConfig.name}
            </h1>

            <Loupe />
        </main>
    )
}

export default Home
